import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const benefits = [
  { title: "Improved cooling performance", icon: "TrendingUp" },
  { title: "Reduced energy consumption", icon: "Zap" },
  { title: "Lower risk of system breakdowns", icon: "Shield" },
  { title: "Longer equipment lifespan", icon: "Clock" },
  { title: "Better indoor air quality", icon: "Wind" }
];

const ACBenefits = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-sm font-bold uppercase tracking-[0.4em] text-[#91756A] mb-8">Benefits of Regular AC Maintenance</h2>
            <h3 className="text-4xl md:text-5xl font-bold text-[#4D4C4A] leading-tight mb-8 italic tracking-tighter">
              A Worthwhile <span className="text-[#91756A]">Investment</span> in Comfort.
            </h3>
            <p className="text-slate-500 text-lg leading-relaxed mb-12">
              Routine maintenance offers significant long-term advantages for building owners and facility managers, 
              ensuring that comfort is never compromised.
            </p>
            
            <div className="grid gap-4">
              {benefits.map((benefit, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="flex items-center gap-4 group p-4 border border-slate-50 hover:border-[#91756A]/20 hover:bg-slate-50 transition-all duration-300"
                >
                  <div className="w-8 h-8 rounded-full bg-[#91756A]/10 flex items-center justify-center group-hover:bg-[#91756A] transition-colors duration-300">
                    <Icon name={benefit.icon} size={14} className="text-[#91756A] group-hover:text-white" />
                  </div>
                  <span className="text-[#4D4C4A] font-bold italic uppercase tracking-tight text-lg">{benefit.title}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="grid grid-cols-2 gap-4"
          >
            <div className="space-y-4">
              <div className="aspect-[4/5] overflow-hidden relative group">
                <Image 
                  src="/assets/images/AC-page/AC-1080px-by-1080px.jpg" 
                  alt="AC Maintenance" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="aspect-square overflow-hidden relative group">
                <Image 
                  src="/assets/images/AC-page/AC-1080px-by-1080px-2.jpg" 
                  alt="AC Service" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
            <div className="space-y-4 pt-12">
              <div className="aspect-square overflow-hidden relative group">
                <Image 
                  src="/assets/images/AC-page/AC-1080px-by-1080px-3.jpg" 
                  alt="HVAC Systems" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="aspect-[4/5] overflow-hidden relative group">
                <Image 
                  src="/assets/images/AC-page/AC-1080px-by-1080px-4.jpg" 
                  alt="Climate Control" 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ACBenefits;